//! yopu need to convert your forms ==> Formik VS React-BootStrap import { Label } from 'react-bootstrap';
import './Login.style.css';
import './Auth.style.scss';

import { ArrowForward } from '@mui/icons-material';
import {Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import axios from '../../Api/axios';
// import { DELAY } from '../../config';
import useAuthSetState from '../../hooks/useAuthSetState';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import useUtilities from '../../hooks/useUtilities';
import { validatePassword } from '../../Utils/validationUtils';
import {buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
//import Footer from '../shared/Footer/Footer';
import PasswordInput from './PasswordInput';

function ResetPassword() {
    const { setBackdropOpen, setOpenSnackBar, setSnackBarMessage,setIsSnackBarError } = useUtilities();

    const {AT} = useParams();
    const {setAuthState,RedirectRoleAndFromBased} = useAuthSetState();
    const axiosPrivate = useAxiosPrivate();
    const [password, setPassword] = useState('');
    const [repeatedPassword, setRepeatedPassword] = useState('');
    const navigate=useNavigate();
    const [passwordError, setPasswordError] = useState();
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const { i18n } = useTranslation();
    // const [backgroundColor, setBgC] = useState(errorColor);
    const [isPasswordShown, setIsPasswordShown] = useState(false);
    const [isRepeatedPasswordShown, setisRepeatedPasswordShown] = useState(false);
    // const classes = useStyles();
    const togglePassword = () => {
        setIsPasswordShown(!isPasswordShown);
    };

    const toggleRepeatedPassword = () => {
        setisRepeatedPasswordShown(!isRepeatedPasswordShown);
    };

    useEffect(() => {
        // setTimeout(() => {
        //     setSignupErrorPassword(null);
        //     // clean error after shoing it
        // }, DELAY);
        validatePassword(password, repeatedPassword,setPasswordError, setIsPasswordValid );

    }, [password, repeatedPassword]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    const resetPassword = async (e) => {
        e.preventDefault();
        setBackdropOpen(true);
        try {
            let response ;
            if(AT){
                response = await axios.post('auth/resetPassword',
                    { password } ,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${AT}`
                        },
                        withCredentials: true
                    }
                );
                setBackdropOpen(false);
                if(response.status == 403){
                    setSnackBarMessage(i18n.t('Ce lien n\'est plus valide, demandez à votre Admin'));
                    setIsSnackBarError(true);
                    setOpenSnackBar(true);
                }
            }
            else {
                response = await axiosPrivate.post('auth/resetPassword',
                    { password },
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }
                );
                setBackdropOpen(false);
            }
            console.log(JSON.stringify(response?.data));
            setPassword('');
            setAuthState({responseData: response.data});
            RedirectRoleAndFromBased({role: response?.data?.user?.role});
        }
        catch (error) {
            console.log(error);
        }
    };

    return (
        <React.Fragment>
            <div className='HomeReset'>
                <div className='BoxReset'>
                    <form>
                        {AT ? <h1 className='Title1Reset'>{i18n.t('Créer un nouveau mot de passe')}</h1> : <h1 className='Title1Reset'>{i18n.t('Mettre à jour le mot de passe')}</h1> }
                        <br/>
                        {/* <p className='Title2Reset'>Doit inclure au moins un symbole ou un chiffre et comporter au moins 8 caractères.</p> */}
                        <div className="Frame109">
                            <PasswordInput
                                label={i18n.t('Nouveau mot de passe*')}
                                sx={{
                                    width: '430px'
                                }}
                                isPasswordShown={isPasswordShown}
                                togglePassword={togglePassword}
                                password={password}
                                setPassword={setPassword}
                                isPasswordValid={isPasswordValid}
                                passwordError={passwordError}
                                // helperText={passwordError}
                            />

                            <PasswordInput
                                label={i18n.t('Confirmer le nouveau mot de passe*')}
                                isConfirmationPassword={true}
                                sx={{
                                    width: '430px'
                                }}
                                isPasswordShown={isRepeatedPasswordShown}
                                togglePassword={toggleRepeatedPassword}
                                password={repeatedPassword}
                                setPassword={setRepeatedPassword}
                                isPasswordValid={isPasswordValid}
                                passwordError={passwordError}
                            />

                        </div>
                        <div className='BasicBtnReset'>
                            <Button
                                type="submit"
                                variant="contained"
                                startIcon={<ArrowForward />}
                                disabled={!isPasswordValid}
                                style={{...buttonStylesBlue(!isPasswordValid),
                                    ...{width: '430px',height: '46px'}
                                }}
                                // className={disabled ? classes.disabledButton : classes.button}
                                //sx={{
                                //    width: '430px',
                                //    height: '46px'
                                //}}
                                onClick={(e) => {
                                    console.log(e);
                                    resetPassword(e);
                                }}
                            > {AT ? i18n.t('Valider') : i18n.t('Mise à jour')}
                            </Button>
                        </div>
                    </form>
                </div>
                {/*<Footer
                    styleProps={{
                        position: 'absolute',
                        left: '0px',
                        top: '570px',
                        width: '100%'
                    }}
                />*/}
            </div>
        </React.Fragment>
    );
}

export default ResetPassword;